import { render, staticRenderFns } from "./VideoSubRenderComponent.vue?vue&type=template&id=30225f21&scoped=true&"
import script from "./VideoSubRenderComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoSubRenderComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSubRenderComponent.vue?vue&type=style&index=0&id=30225f21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30225f21",
  null
  
)

export default component.exports